var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15.877",
        height: "16",
        viewBox: "0 0 15.877 16",
      },
    },
    [
      _c("path", {
        attrs: {
          id: "Path_1",
          "data-name": "Path 1",
          d: "M-121.181,63.714a.61.61,0,0,1-.355-.619c0-2.342,0-4.683.005-7.025a1.215,1.215,0,0,0-.344-.872q-2.861-3.095-5.713-6.2a.762.762,0,0,1,.351-1.267,1,1,0,0,1,.216-.019q7.158,0,14.316,0a.716.716,0,0,1,.7.435.712.712,0,0,1-.132.838q-.858.939-1.721,1.873-2.031,2.2-4.062,4.408a1.05,1.05,0,0,0-.283.739c0,1.436,0,2.873,0,4.309a1.08,1.08,0,0,1-.266.744l-2.158,2.488a.715.715,0,0,1-.243.166Z",
          transform: "translate(127.804 -47.714)",
          fill: "#1aa3da",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }